import React, { useState, useEffect } from 'react'
import { ScrollView, View, StyleSheet, KeyboardAvoidingView } from "react-native"
import { Divider, Card, Button, TextInput as Input } from 'react-native-paper'
import axios from 'axios'
import { Picker } from '@react-native-picker/picker'
import DropDown from "react-native-paper-dropdown"

import { theme } from '../../core/theme'
import {
  TextInput,
  DialogCostum,
  Loader,
} from '../../components'
import Background from '../../components/Background'

export default function SPRP0016({ route, navigation }) {
  const homeprm = navigation.getState();
  const home = homeprm.routes[0].state.routes[0].params;
    const date = new Date(home.oprdt)
  // const date = new Date() // 24/01/2024 read date current not oprdt
  const [errorMessage, setErrorMessage] = useState(null)
  const [visible, setVisible] = useState(false)
  const [spin, setSpin] = useState()
  const [duedate, setDuedate] = useState({ value: 12, error: '' })
  
  const hideDialog = () => {
    setVisible(false)
  }

  const [year, setYear] = useState({ value: date.getFullYear(), error: '' })
  const [jangka, setJangka] = useState({ value: '5', error: '' })
  const [metode, setMetode] = useState({ value: 'SPRP0016A', error: '' })
  const [format, setFormat] = useState({ value: 'xlsx', error: '' })
  const [jangkaShow, setJangkaShow] = useState(true);
  const [formats, setFormats] = useState({
    list:[
      { label: "Excel", value: 'xlsx' },
      { label: "CSV", value: 'csv' },
    ]
  });
  const [month, setMonth] = useState({ value: date.getMonth(), error: '' })
  const [collect, setCollect] = useState({ value: 'D', error: '' })
  
  const [metodeDropDown, setMetodeDropDown] = useState(false);
  const [formatDropDown, setFormatDropDown] = useState(false);
  const metodes = { 
    list:[
      { label: "LGD Expected Recoveries", value: 'SPRP0016A' },
      { label: "LGD Collateral Shortfall", value: 'SPRP0016B' },
      { label: "LGD Weighted Average", value: 'SPRP0016C' },
    ]
  }
  const [monthDropDown, setmonthDropDown] = useState(false);
  const collects = {
    list: [
      { label: '> 1 Tahun', value: 'D' },
      { label: 'Termasuk <= 1 Tahun', value: 'A' },
    ],
  }
  const [collectDropDown, setCollectDropDown] = useState(false)

  // const formats = { 
  //   list:[
  //     { label: "Excel", value: 'xlsx' },
  //     { label: "CSV", value: 'csv' },
  //   ]
  // }

  const [months, setmonths] = useState({
      list:[],
    });

  const yearValidator = (v) => {
    if (!v) return "Periode Tahun tidak boleh kosong."
    if (parseInt(v)<1000 || parseInt(v)>9999 || isNaN(parseInt(v))) return "Periode Tahun tidak valid."
    if (v>date.getFullYear()) return "Periode Tahun tidak boleh lebih besar dari "+date.getFullYear()+"."
    return ''
  }

  const jangkaValidator = (v) => {
    if (!v && v!==0 && visible) return "Jangka Waktu (Tahun) tidak boleh kosong."
    // if (v<5) return "Jangka Waktu (Tahun) tidak boleh lebih kecil dari 5."
    return ''
  }

  const formatValidator = (v) => {
    if (!v && v!==0) return "Cetak Ke tidak boleh kosong."
    return ''
  }

  const metodeValidator = (v) => {
    if (!v) return "Metode PD tidak boleh kosong."
    return ''
  }

  const collectValidator = (v) => {
    if (!v) return 'Kolek tidak boleh kosong.'
    return ''
  }

  const monthsOnChange = (val) => {
      var list = [
        { label: "Januari", value: 0 },
        { label: "Februari", value: 1 },
        { label: "Maret", value: 2 },
        { label: "April", value: 3 },
        { label: "Mei", value: 4 },
        { label: "Juni", value: 5 },
        { label: "Juli", value: 6 },
        { label: "Agustus", value: 7 },
        { label: "September", value: 8 },
        { label: "Oktober", value: 9 },
        { label: "November", value: 10 },
        { label: "Desember", value: 11, disabled: true },
      ]
  
      if(val > date.getFullYear()){
        setMonth({ value: '', error: '' })
      }

      if (val < date.getFullYear() && collect.value == 'D'){
        setmonths({
          list: [{ label: 'Desember', value: 11, disabled: true }],
          value: 11
        })
      }else{
        setmonths({
          list: val > date.getFullYear() ? [] : (val<date.getFullYear() ? list : list.filter((v) => 
            v.value <= date.getMonth()
          )),
        })
      }
    }
  
    useEffect(() => {
      monthsOnChange(date.getFullYear())
    }, []);

  const onCancel = () => {    
    setYear({ value: date.getFullYear(), error: '' })
    setJangka({ value: '5', error: '' })
    setMetode({ value: 'SPRP0016A', error: '' })
    setJangkaShow(true);
    setFormats({
      list:[
        { label: "Excel", value: 'xlsx' },
        { label: "CSV", value: 'csv' },
      ]
    });
    setCollect({value: 'D', error: ''})
  }

  const onSubmit = async () => {
    const yearError = yearValidator(year.value)
    const jangkaError = jangkaValidator(jangka.value)
    const metodeError = metodeValidator(metode.value)
    const formatError = formatValidator(format.value)
    const collectError = collectValidator(collect.value)

    setYear({ ...year, error: yearError })
    setJangka({ ...jangka, error: jangkaError })
    setMetode({ ...metode, error: metodeError })
    setFormat({ ...format, error: formatError })
    // setCollect({ ...collect, error: collectError })
    if (yearError || jangkaError || metodeError || formatError) {
      return
    }

    setSpin(true)
    
    try {
      await axios.post(process.env.REACT_APP_URL_API + "SPRP0016/read",  {
        year:year.value,
        jangka:jangka.value,
        format:format.value,
        method:metode.value,
        bulan:month.value,
        collect:collect.value
      }, {timeout: 1800000})
      .then(res => {
        
        setSpin(false)

        if (!res.data.data){
          if(res.data.error.responseCode){
            setErrorMessage(`${res.data.error.responseCode} - ${res.data.error.responseMsg}`);
          }else if(res.data.error.message){
            setErrorMessage(res.data.error.message);
          }else{
            setErrorMessage(res.data.error);
          }
          setVisible(true);
        }else{
          var linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ res.data?.data?.content;
          var downloadLink = document.createElement("a");

          downloadLink.href = linkSource;
          downloadLink.download = res.data?.data?.filenm;
          downloadLink.click();
          
          if(res.data?.data?.path) window.location.href = process.env.REACT_APP_URL_API + res.data.data.path;
        }
      })
      .catch(err => {
        setSpin(false)
        console.log(err);
        setErrorMessage(err.code==="ECONNABORTED"? "Server Luring": (err.message?err.message:JSON.stringify(err)) );
        setVisible(true);
      });
    } catch (err) {
      setSpin(false)
      console.log(err);
      setErrorMessage('Server Luring');
      setVisible(true);
    }

  }

  const onChangeMetode = (v) => {
    setMetode({ value: v, error: '' });
    if (v == 'SPRP0016A') {
      setJangkaShow(true);
      setJangka({value: '5'});
      setFormats({
        list:[
          { label: "Excel", value: 'xlsx' },
          { label: "CSV", value: 'csv' },
        ]
      });
      setCollect({value: 'D', error: '' })
    } else {
      setJangkaShow(false);
      setJangka({value: ''});
      setFormats({
        list:[
          { label: "Excel", value: 'xlsx' },
        ]
      });
      setCollect({value: '', error: '' })
    } 
  }

  return (
    <Background>
      <ScrollView>
        <KeyboardAvoidingView style={styles.container} behavior="padding">
          <View>
            <Card style={styles.gridView}>
              <Card.Title title="Parameter" />
              <Divider />
              <Card.Content>
                <View>
                  <View style={styles.dropDown}>
                    <DropDown
                      label={'Metode PD'}
                      mode={'outlined'}
                      value={metode.value}
                      setValue={(text) => onChangeMetode(text)}
                      list={metodes.list}
                      error={!!metode.error}
                      errorText={metode.error}
                      visible={metodeDropDown}
                      showDropDown={() => setMetodeDropDown(true)}
                      onDismiss={() => setMetodeDropDown(false)}
                      inputProps={{
                        right: (
                          <Input.Icon
                            name={metodeDropDown ? 'menu-up' : 'menu-down'}
                          />
                        ),
                      }}
                    />
                    {metode.error ? (
                      <Text style={styles.error}>{metode.error}</Text>
                    ) : null}
                  </View>

                  {jangkaShow && (
                    <View style={styles.dropDown}>
                      <DropDown
                        label={'Kolek Macet'}
                        mode={'outlined'}
                        value={collect.value}
                        setValue={(text) => setCollect({value : text})}
                        list={collects.list}
                        error={!!collect.error}
                        errorText={collect.error}
                        visible={collectDropDown}
                        showDropDown={() => setCollectDropDown(true)}
                        onDismiss={() => setCollectDropDown(false)}
                        inputProps={{
                          right: (
                            <Input.Icon
                              name={collectDropDown ? 'menu-up' : 'menu-down'}
                            />
                          ),
                        }}
                      />
                      {collect.error ? (
                        <Text style={styles.error}>{collect.error}</Text>
                      ) : null}
                    </View>
                  )}
                  {jangkaShow && (
                    <TextInput
                      label="Jangka Waktu (Tahun)"
                      returnKeyType="next"
                      value={jangka.value}
                      onChangeText={(text) =>
                        setJangka({
                          value: text.replace(/[^0-9]/g, ''),
                          error: '',
                        })
                      }
                      errorText={jangka.error}
                    />
                  )}
                  <TextInput
                    label="Periode Tahun"
                    returnKeyType="next"
                    value={year.value}
                    onChangeText={(text) => {monthsOnChange(text); setYear({ value: text.replace(/[^0-9]/g, ''), error: '' })}}
                    // error={!!year.error}
                    errorText={year.error}
                  />
                  <View style={styles.dropDown}>
                    <DropDown
                      label={'Bulan'}
                      mode={'outlined'}
                      value={month.value}
                      setValue={(text) => setMonth({ value: text, error: '' })}
                      list={months.list}
                      error={!!month.error}
                      errorText={month.error}
                      visible={monthDropDown}
                      showDropDown={() => setmonthDropDown(true)}
                      onDismiss={() => setmonthDropDown(false)}
                      inputProps={{
                        right: (
                          <Input.Icon
                            name={monthDropDown ? 'menu-up' : 'menu-down'}
                          />
                        ),
                      }}
                    />
                    {duedate.error ? (
                      <Text style={styles.error}>{duedate.error}</Text>
                    ) : null}
                  </View>
                  <View style={styles.dropDown}>
                    <DropDown
                      label={'Cetak Ke'}
                      mode={'outlined'}
                      value={format.value}
                      setValue={(text) => setFormat({ value: text, error: '' })}
                      list={formats.list}
                      error={!!format.error}
                      errorText={format.error}
                      visible={formatDropDown}
                      showDropDown={() => setFormatDropDown(true)}
                      onDismiss={() => setFormatDropDown(false)}
                      inputProps={{
                        right: (
                          <Input.Icon
                            name={formatDropDown ? 'menu-up' : 'menu-down'}
                          />
                        ),
                      }}
                    />
                    {format.error ? (
                      <Text style={styles.error}>{format.error}</Text>
                    ) : null}
                  </View>
                </View>
              </Card.Content>
              <Divider />
              <Card.Actions style={{ justifyContent: 'right' }}>
                <Button onPress={onCancel}>Batal</Button>
                <Button onPress={onSubmit}>Cetak</Button>
              </Card.Actions>
            </Card>
          </View>
        </KeyboardAvoidingView>
      </ScrollView>

      {spin && <Loader size="large" animating={spin} />}
      <DialogCostum props={{ visible, hideDialog, message: errorMessage }} />
    </Background>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 50,
    padding: 10,
    maxWidth: 340,
    width: '100%',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  gridView: {
    marginTop: 10,
  },
  error: {
    fontSize: 13,
    color: theme.colors.error,
    paddingTop: 8,
  },
  dropDown: {
    marginVertical: 12,
  },
});
